//
// locales/glitch/pl.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/flavours/glitch/locales/pl';
import localeData from 'react-intl/locale-data/pl.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
